module.exports = __webpack_public_path__ + "static/floralbib-b353578f54bcc75a4747bea209439c84.jpeg";